import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { Watch } from 'vue-property-decorator';

@Component({
    props: {
        type: {
            type: String,
            default: 'iron-core',
        },
        selected: {
            type: Object,
            default: null,
        },
    },
    computed: mapState({
        series: state => state.motor_types,
    }),
})
export default class MotorSelector extends Vue {
    name = 'motor-selector';

    nameFilter = '';
    peakForceFilter = '';
    continuousForceFilter = '';
    peakCurrentFilter = '';
    thermResFilter = '';
    vMaxFilter = '';
    bemfFilter = '';

    filtered = [];
    serie = {};

    get motors() {
        let serie = this.series.find(s => {
            return (
                s.name !== undefined &&
                this.type !== undefined &&
                s.name.toLowerCase().replace(/\s/g, '-') ===
                    this.type.toLowerCase().replace(/\s/g, '-')
            );
        });

        if (serie === undefined) {
            this.serie = {};
            return [];
        } else {
            this.serie = serie;
        }

        if (this.serie.motors === undefined) {
            return [];
        }

        return this.serie.motors;
    }

    mounted() {
        this.order('asc', 'peak_force');
    }

    order(order, field) {
        if (this.filtered.length === 0) {
            this.filter();
        } else {
            this.filtered = this.filtered.sort((first, second) => {
                if (first[field] < second[field]) {
                    return order === 'asc' ? -1 : 1;
                }

                if (first[field] > second[field]) {
                    return order === 'asc' ? 1 : -1;
                }

                return 0;
            });
        }
    }

    @Watch('nameFilter')
    @Watch('peakForceFilter')
    @Watch('continuousForceFilter')
    @Watch('peakCurrentFilter')
    @Watch('thermResFilter')
    @Watch('series')
    @Watch('vMaxFilter')
    @Watch('bemfFilter')
    filter() {
        let name = this.nameFilter.toLowerCase();
        let peak = this.peakForceFilter || 0;
        let contin = this.continuousForceFilter || 0;
        let peakCurrent = this.peakCurrentFilter || 0;
        let vmax = this.vMaxFilter || 0;
        let bemf = this.bemfFilter || 0;

        let arr = this.motors.filter(motor => {
            return (
                motor.name !== undefined &&
                motor.name.toLowerCase().indexOf(name) > -1 &&
                motor.peak_force >= peak &&
                motor.motor_force_constant >= contin &&
                motor.peak_current >= peakCurrent &&
                motor.bemf >= bemf &&
                motor.maximum_speed >= vmax
            );
        });

        this.filtered = arr.sort((a, b) => {
            return a.order - b.order;
        });
    }

    select(motor) {
        this.$emit('select', motor);
    }

    changeSerie() {
        this.$emit('change-serie');
    }

    getPeakForceUnit() {
        if (this.serie.category === 'Torque') {
            return 'Nm';
        }
        return 'N';
    }

    getForceConstantUnit() {
        if (this.serie.category === 'Torque') {
            return this.$t('profiles.nm/aavg');
        }
        return this.$t('profiles.n/aavg');
    }

    getSpeedUnit() {
        if (this.serie.category === 'Torque') {
            return 'rpm';
        }

        return 'm/s';
    }

    getSpeedVoltageUnit() {
        return this.$t('profiles.vmax');
    }

    getBEMFUnit() {
        if (this.serie.category === 'Torque') {
            return this.$t('vpeak/krpms');
        }

        return this.$t('vpeak/m/s');
    }

    getMotorMaxSpeedWithUnit(motor) {
        const speedUnit = this.getSpeedUnit();
        const voltageUnit = motor.maximum_speed_voltage
            ? motor.maximum_speed_voltage + ' ' + this.getSpeedVoltageUnit()
            : 'Tc';
        return `${motor.maximum_speed} ${speedUnit} @ ${voltageUnit}`;
    }
}

Vue.component('motor-selector', MotorSelector);
